// eslint-disable-next-line import/no-default-export
export default window.__locale__ || {
  locale: 'en',
  messages: {},
};
